// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"List_listContainer__3mACH","list":"List_list__4IObr","listItem":"List_listItem__uVrmM","list_lightText":"List_list_lightText__2C64_"};